// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "bootstrap/dist/js/bootstrap.bundle.min.js" // Bootstrap JS features (modals, dropdowns, etc.)
import Dropzone from "dropzone" // File upload functionality
import "./controllers"

// ActiveStorage Direct Upload support
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Only load Shopify app JavaScript on Shopify app pages
if (window.location.pathname.startsWith('/shopifyapp')) {
  import("./shopify_app/index.js")
}

// Make Dropzone available globally for forms
window.Dropzone = Dropzone;

import "trix"
import "@rails/actiontext"

